import { useEffect } from 'react'

const PIXEL_ID = '813466921797001'

declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: (...args: any[]) => void
  }
}

let initialized = false

export function initMetaPixel() {
  if (initialized || typeof window === 'undefined') return

  const f = window as any
  const b = document
  const e = 'script'
  const v = 'https://connect.facebook.net/en_US/fbevents.js'

  if (f.fbq) return

  const n: any = (f.fbq = function (...args: any[]) {
    if (n.callMethod) {
      n.callMethod.apply(n, args)
    } else {
      n.queue.push(args)
    }
  })

  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = [] as any[]

  const t = b.createElement(e) as HTMLScriptElement
  t.async = true
  t.src = v
  const s = b.getElementsByTagName(e)[0]
  s?.parentNode?.insertBefore(t, s)

  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')

  initialized = true
}

export function trackAddToCart() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Protocolo Vientre Plano 48H',
      content_type: 'product',
      value: 6.39,
      currency: 'USD',
    })
  }
}

export function useMetaPixel() {
  useEffect(() => {
    initMetaPixel()
  }, [])
}
